import { gql } from 'react-apollo';

export default gql`
  mutation loginShared($token: String!, $refTenantId: ID) {
    loginShared(token: $token, refTenantId: $refTenantId)
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/loginShared.js